import Repository from '../axios'

const  resource = "/landlord/external_a_p_is";

export default {
  get() {
    return Repository.get(`${resource}`)
  },
  getExternalServiceDetails(id){
    return Repository.get(`${resource}/${id}`)
  },
  createExternalService(payload){
    return Repository.post(`${resource}`, payload)
  },
  updateExternalService(id, payload){
    return Repository.put(`${resource}/${id}`, payload)
  },
};
